import React from "react";
import EventListInfo from "./EventListInfo";
import Config from "Data";
import moment from "moment";
import styled from "styled-components";
import { theme } from "Theme";

const Item = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  width: 100%;
  position: relative;
  max-width: 100%;
  min-height: 100%;
  display: flex;
  flex-flow: row;
  user-select: none;
  cursor: pointer;
  transition: 0.25s;
  border-radius: ${theme.borderRadius.ui};
  overflow: hidden;
  &.float:hover {
    transform: translateY(-8px);
    box-shadow: 0 10px 10px -10px rgba(#000, 1);
  }
`;

class EventItem extends React.Component {
  render() {
    let {
      banner,
      big,
      brandName,
      className,
      countdown,
      event,
      eventCity,
      eventCountry,
      eventCountryISO,
      eventDate,
      eventEnd,
      eventEndDate,
      eventId,
      eventName,
      eventPanel,
      eventRegion,
      eventSponsors,
      eventStart,
      eventState,
      eventTime,
      eventType,
      eventURL,
      featured,
      track,
      teaser,
      item_action
    } = this.props;

    // const futureEvent = moment(eventDate).isAfter(moment(), "day")

    return (
      <Item  onClick={(e) => { item_action && item_action(e) }} className={`${className ? className : ""}`}>
        <EventListInfo
          banner={banner}
          big={big}
          brandName={brandName}
          countdown={countdown}
          eventDate={eventDate}
          eventCity={eventCity}
          eventEnd={eventEnd}
          eventEndDate={eventEndDate}
          eventId={eventId}
          eventType={eventType}
          eventTime={eventTime}
          eventPanel={eventPanel}
          eventRegion={eventRegion}
          eventCountryISO={eventCountryISO}
          eventSponsors={eventSponsors}
          eventStart={eventStart}
          eventURL={eventURL}
          featured={featured}
          track={track}
          eventName={eventName}
          teaser={teaser}
          item_action={item_action}
          
        />
      </Item>
    );
  }
}

export default EventItem;
